import React from 'react'
import { Link as RouterLink } from 'react-router-dom'
import Typography from '@mui/material/Typography'
import Link from '@mui/material/Link'

const LinkRouter = ({ active = true, ...props }) => active
  ? <Link {...props} component={RouterLink} />
  : <Typography {...props} color="textPrimary"/>

export default LinkRouter